import { Loading } from "@sweco-se/reality-frontend";
import type { QueryClient } from "@tanstack/react-query";
import {
  createRouter,
  parseSearchWith,
  stringifySearchWith,
} from "@tanstack/react-router";
import type { AuthContextProps } from "react-oidc-context";

import { queryClient } from "@/api.ts";
import { routeTree } from "@/routeTree.gen.ts";

function parseSearch(value: string) {
  if (/^\d+$/.test(value)) {
    return value;
  }
  return JSON.parse(value);
}

function stringifySearch(value: any) {
  if (typeof value === "string" && /^\d+$/.test(value)) {
    return value;
  }
  return JSON.stringify(value);
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: undefined,
  },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultPendingComponent: Loading,
  basepath: "/",
  parseSearch: parseSearchWith(parseSearch),
  stringifySearch: stringifySearchWith(stringifySearch, parseSearch),
});
// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export interface RouterContext {
  queryClient: QueryClient;
  auth: AuthContextProps | undefined;
}
